function CheckSameIDAttachment(role_flag: string) {
  const credential_raw = JSON.parse(localStorage.getItem('credential-decoded')!)
  if (credential_raw?.role_flag === role_flag) return true
  else return false
}

export {CheckSameIDAttachment}
